module.exports = __webpack_public_path__ + "img/html-blocks.f2c04ec8.svg";